import { gql } from '@apollo/client';

import PLAN_DETAILS_FRAGMENT from './PlanDetailsFragment.graphql.js';
import FEATURE_SET_DETAILS_FRAGMENT from './FeatureSetDetailsFragment.graphql.js';
import LIMIT_SET_DETAILS_FRAGMENT from './LimitSetDetailsFragment.graphql.js';

export default gql`
  query CompanyBilling {
    viewer {
      id
      company {
        id
        databaseId
        subscriptionEnd
        trialEnd
        trialed

        plan {
          ...PlanDetails
        }

        featureSet {
          ...FeatureSetDetails
        }
        limitSet {
          ...LimitSetDetails
        }
        availablePlans {
          ...PlanDetails

          eligiblePlan
          messages {
            messageTitle
            content
            buttonText
            infoText
          }
        }
      }
    }
  }
  ${PLAN_DETAILS_FRAGMENT}
  ${FEATURE_SET_DETAILS_FRAGMENT}
  ${LIMIT_SET_DETAILS_FRAGMENT}
`;
